require('expose?CommunicatorDetector!../../../public/javascripts/communicator_detector.js')
require('expose?T!expose?Translations!../../../public/javascripts/translations.js')
require('expose?$!expose?jQuery!../../../public/javascripts/jquery-2.2.3.js')
require('../../../public/javascripts/jquery-migrate-1.3.0.js')
require('expose?_!../../../public/javascripts/underscore-amd-1.4.4.js')
require('expose?Backbone!../../../public/javascripts/backbone-amd-1.0.0.js')
require('expose?async!../../../public/javascripts/async.js')
require('expose?rwgps!../../../public/javascripts/rwgps/rwgps.js')
require('../../../public/javascripts/on_site_widgets.js')
require('../../../public/javascripts/jquery/jquery.tmpl.js')
require('../../../public/javascripts/jquery/jquery.jgrowl.js')
require('../../../public/javascripts/jquery/jquery.json-1.3.js')
require('../../../public/javascripts/jquery/jquery.form.js')
require('../../../public/javascripts/jquery/jquery.hoverintent.js')
require('../../../public/javascripts/jquery/thickbox.modified.js')
require('../../../public/javascripts/jquery/jquery.pointout.js')
require('../../../public/javascripts/jquery/jquery.prettyLoader.js')
require('../../../public/javascripts/jquery/jquery.cookie.js')
require('../../../public/javascripts/rails.js')
require('../../../public/javascripts/quicksilver.js')
require('../../../public/javascripts/application.js')
require('expose?Comments!../../../public/javascripts/comments.js')
require('expose?Favorites!../../../public/javascripts/favorites.js')
require('expose?Photosets!../../../public/javascripts/photosets.js')
require('../../../public/javascripts/colorbox.js')
require('../../../public/javascripts/bootstrap.js')

// revised layout
require('../../../public/javascripts/pages/home.js')



// WEBPACK FOOTER //
// ./app/assets/javascripts/base.js